import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import {
  fetchInboxMessages,
  fetchSentMessages,
  fetchDraftMessages,
  sendMessage,
  saveDraftMessage,
  deleteDraftMessage,
  fetchUnreadCount,
} from '../../../state/redux/actions/messageActions.js'

const useMessage = (options = { fetch: 'inbox' }) => {
  const dispatch = useDispatch()
  const { inbox, sent, drafts, unreadCount, loading, error } = useSelector(state => state.message)

  useEffect(() => {
    if (options.fetch === 'inbox') dispatch(fetchInboxMessages())
    if (options.fetch === 'sent') dispatch(fetchSentMessages())
    if (options.fetch === 'drafts') dispatch(fetchDraftMessages())
    if (options.fetch === 'unreadCount') dispatch(fetchUnreadCount())
  }, [dispatch, options.fetch])

  return {
    inbox,
    sent,
    drafts,
    unreadCount,
    loading,
    error,
    fetchInbox: () => dispatch(fetchInboxMessages()),
    fetchSent: () => dispatch(fetchSentMessages()),
    fetchDrafts: () => dispatch(fetchDraftMessages()),
    fetchUnreadCount: () => dispatch(fetchUnreadCount()),
    sendMessage: data => dispatch(sendMessage(data)),
    saveDraft: data => dispatch(saveDraftMessage(data)),
    deleteDraft: id => dispatch(deleteDraftMessage(id)),
  }
}

export default useMessage